import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientEmployeeRelationshipRoutingModule } from './client-employee-relationship-routing.module';
import { ClientEmployeeRelationshipComponent } from '../client-employee-relationship/client-employee-relationship.component';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { MaskedTextBoxModule, NumericTextBoxAllModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  declarations: [ClientEmployeeRelationshipComponent],
  imports: [
    CommonModule,
    FormsModule,
    GridModule,
    ReactiveFormsModule,
    MultiselectDropdownModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    NgSelectModule,
    ClientEmployeeRelationshipRoutingModule
  ],
  exports:[ClientEmployeeRelationshipComponent]
})
export class ClientEmployeeRelationshipModule { }
